import { GQLContentMarqueeFragment } from '@theprintbar/graphql';
import { BrandColours, cn } from '@theprintbar/shared';
import { BrandStarAnimated } from '@theprintbar/ui';
import { createElement } from 'react';

interface MarqueeProps {
	content: GQLContentMarqueeFragment;
}

export function Marquee({ content }: MarqueeProps) {
	const { marqueeText, marqueeColour, marqueeLink, marqueeIcon, marqueeLarge } = content;
	if (!marqueeText?.length) return null;

	const length = marqueeLarge && marqueeText.length > 15 ? 5 : 10;
	const bottomProps = marqueeLink ? { href: marqueeLink } : {};

	//Make double so we can get unique keys for each element
	const elements = new Array(length * 2).fill('').map((v, index) => (
		<span key={`${marqueeText}-${index}`} className={cn('flex items-center')}>
			<BrandStarAnimated
				className={cn('fill-blue', marqueeLarge ? 'lg:w-[58px] lg:h-[58px] mx-6 w-[35px] h-[35px] mb-1' : 'h-4 w-4 mx-4')}
			/>
			<p className={cn(marqueeLarge && 'font-black lg:text-[5rem] text-[3rem] font-gravity uppercase mt-2')}>{marqueeText}</p>
		</span>
	));

	return (
		<div
			className={cn('relative flex overflow-hidden !mt-0', 'border-y border-blue')}
			style={{ backgroundColor: marqueeColour || BrandColours.Blue }}
		>
			{createElement(
				marqueeLink ? 'a' : 'div',
				{ className: 'flex py-4 lg:py-5 mb-1 lg:mt-1 animate-marquee whitespace-nowrap ', ...bottomProps },
				elements.slice(0, length),
			)}
			{createElement(
				marqueeLink ? 'a' : 'div',
				{
					className: 'flex absolute top-0 mb-1 lg:mt-1 py-4 lg:py-5 animate-marquee2 whitespace-nowrap',
					...bottomProps,
				},
				elements.slice(length),
			)}
		</div>
	);
}
